<template>
  <div class="frame-container" ref="containerRef">
    <img v-if="!isLoaded || !canPlay" :src="require('@/assets/images/' + urlRoot + indexRange[0] + '.png')" alt="default img" />
    <img v-else ref="imgRef" :alt="'frame animation'" />
  </div>
</template>

<script>
export default {
  props: {
    urlRoot: {
      type: String,
      required: true
    },
    indexRange: {
      type: Array,
      required: true
    },
    loop: {
      type: Boolean,
      default: false
    },
    canPlay: {
      type: Boolean,
      default: true
    },
    speed: {
      type: Number,
      default: 42
    }
  },
  data() {
    return {
      isLoaded: false,
      store: { length: 0 }
    };
  },
  computed: {
    maxLength() {
      return this.indexRange[1] - this.indexRange[0] + 1;
    }
  },
  methods: {
    updateProgress() {
      const newPercent = Math.round((100 * this.store.length) / this.maxLength);

      if (newPercent === 100) {
        this.isLoaded = true;
      }
    },
    play() {
      if (!this.$refs.imgRef) return;

      let index = this.indexRange[0];

      const step = () => {
        if (index > this.indexRange[1]) {
          if (this.loop) {
            index = this.indexRange[0];
          } else {
            return;
          }
        }

        this.$refs.imgRef.src = this.store[index].src;
        index++;

        if (index <= this.indexRange[1] || this.loop) {
          setTimeout(step, this.speed);
        } else {
          this.$emit("finallyOver", true);
        }
      };

      step();
    },
    preloadImages() {
      for (let i = this.indexRange[0]; i <= this.indexRange[1]; i++) {
        const img = new Image();
        img.onload = () => {
          this.store.length++;
          this.$set(this.store, i, img);
          this.updateProgress();
        };
        img.onerror = () => {
          this.store.length++;
          this.updateProgress();
        };
        img.src = this.getImageUrl(i);
      }
    },
    getImageUrl(i) {
      return require(`@/assets/images/${this.urlRoot}${i}.png`);
    }
  },
  watch: {
    isLoaded(val) {
      if (val && this.canPlay) {
        this.$nextTick(() => {
          this.play();
        });
      }
    },
    canPlay(val) {
      if (val && this.isLoaded) {
        this.$nextTick(() => {
          this.play();
        });
      }
    }
  },
  mounted() {
    this.preloadImages();
  }
};
</script>

<style lang="scss" scoped>
@import url(./index.scss);
</style>
